import { render } from "./UserRegisterInput.vue?vue&type=template&id=5ad8ccc2&scoped=true"
import script from "./UserRegisterInput.vue?vue&type=script&lang=js"
export * from "./UserRegisterInput.vue?vue&type=script&lang=js"

import "./UserRegisterInput.vue?vue&type=style&index=0&id=5ad8ccc2&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad8ccc2"]])

export default __exports__